module.exports = __webpack_public_path__ + "img/earth_atmos_2048.e15eb8d2.jpg";